/* eslint-disable prettier/prettier */
import Head from 'next/head';

import {
  PageWrapper,
  TextIntro,
  Offerings,
  Team,
} from '@components';

const AboutUsPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>About Us | Valearnis</title>
        <meta
          name="description"
          content="Valearnis is an educational web-app that educates high school students with lessons, quizzes, characters, and more! Created by EdTech startup ManezCo."
        />
      </Head>
      <PageWrapper>
        <TextIntro
          heading={'What is Valearnis?'}
          body={
            'Valearnis is an educational platform that is fully designed around a student-centric ecosystem. Within the world of Valearnis, you will find:'
          }
        />
        <Offerings />
        <Team />
      </PageWrapper>
    </>
  );
};

export default AboutUsPage;
